import styled from "styled-components";
import { Link } from "react-router-dom";

export const Sekcja = styled.section`
  scroll-margin-top: 86px;
  display: grid;
  grid-template-columns: minmax(300px,.85fr) minmax(0,1.15fr);
  gap: clamp(30px,5vw,70px);
  padding: 90px clamp(16px,5vw,72px);
  align-items: center;
  background: #fff;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
    gap: 20px;
    padding: 70px 16px;
    justify-items: center;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    gap: 10px;
    text-align: left;
    padding-top: 32px;
    padding-bottom: 32px;
  }
`;

export const Zdjecie = styled.img`
  width: 100%;
  max-width: 560px;
  height: 100%;
  max-height: 720px;
  object-fit: cover;
  border-radius: 30px;

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    order: 2; 
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    height: 330px;
    border-radius: 24px;
  }
`;

export const Tytul = styled.h2`
  margin: 0 0 10px;
  font-size: clamp(26px, 3vw, 36px);
  line-height: 1.18;
`;

export const Podtytul = styled.p`
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
`;

export const Opis = styled.div`
  padding: clamp(22px,4vw,38px);
  max-width: 650px;
  border: 1px solid #e4e8e3;
  border-radius: 28px;
  background: #f8faf7;

  .consultation-details { font-size:13px; line-height:1.5; }
  .consultation-details summary { cursor:pointer; padding:10px 0; min-height:44px; }
  .eyebrow { color: ${({ theme }) => theme.color.green}; font-size: 13px; font-weight: 900; letter-spacing: .09em; text-transform: uppercase; }
  .response-note { margin-top: 14px; padding: 12px 14px; border-radius: 14px; background: #eef3ec; color: #35503a; font-size: 14px; line-height: 1.5; }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletMax}px) {
    order: 1;
  }
`;

export const Kontener = styled.form`
  font-size: 14px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 600px;
  width: 100%;
`;

export const Oswiadczenie = styled.p`
  font-size: 14px;
  margin: 5px 0;
`;

export const Dane = styled.div`
  display: grid;
  grid-template-columns: repeat(3,minmax(0,1fr));
  gap: 12px;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

export const Wiersz = styled.label`
  display: flex;
  flex-direction: column;
`;

export const Paragraf = styled.p`
  margin: 5px;
  font-weight: 700;
  small { color: #747974; font-weight: 400; }
`;

export const Input = styled.input`
  border-radius: 14px;
  width: 100%;
  min-height: 48px;
  padding: 0 14px;
  border: 1px solid #d8ddd8;
  background: #fff;

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 100%;
  }
`;

export const Select = styled.select`
  width: 100%; min-height: 48px; padding: 0 14px; border: 1px solid #d8ddd8; border-radius: 14px; background: #fff;
`;

export const Textarea = styled.textarea`
  border-radius: 14px;
  width: 100%;
  height: 72px;
  border: 1px solid #d8ddd8;
  background: #fff;
  padding: 10px;
`;

export const Button = styled.button`
  cursor: pointer;
  width: 280px;
  height: 48px;
  margin-top: 5px;
  font-size: 16px;
  border-radius: 34px;
  background-color: ${({ theme }) => theme.color.green};
  border: none;
  color: ${({ theme }) => theme.color.white};
  text-transform: uppercase;
  font-weight: bold;
  cursor: pointer;

  &:disabled { opacity: 0.65; cursor: wait; }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) { width: 100%; }
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
  font-style: italic;
  color: ${({ theme }) => theme.color.black};

  &:hover {
    text-decoration: underline;
  }
`;

export const Przyciski = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;

  > [role="status"], > [role="alert"] { flex-basis: 100%; margin: 0; }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    justify-content: center;
  }
`;

export const Telefon = styled.a`
  color: ${({ theme }) => theme.color.green};
  font-weight: 700;
  line-height: 1.4;
  text-decoration: none;

  strong { white-space: nowrap; }
  &:hover { text-decoration: underline; }

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMax}px) {
    width: 100%;
    text-align: center;
  }
`;

